import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
import api from "@/lib/api";

export default function ApplicationTips() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/application-tips").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div className="App" data-testid="page-application-tips">
      <NavBar />
      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-14">
        <div className="aa-eyebrow mb-3">Application tips</div>
        <h1 className="font-display text-4xl lg:text-5xl leading-tight">
          A few quick <span className="serif-italic">how-to's</span>.
        </h1>
        <p className="mt-4 text-[var(--aa-text-2)] max-w-2xl">Follow the order listed in your protocols. When in doubt, follow this order:</p>

        {!data ? (
          <div className="aa-eyebrow mt-10">Loading…</div>
        ) : (
          <>
            <div className="aa-card aa-card-warm p-7 mt-8">
              <div className="aa-eyebrow mb-4">Order of application — thinner to thicker</div>
              <ol className="space-y-3">
                {data.order.map((s, i) => (
                  <li key={i} className="flex gap-4 items-start" data-testid={`tip-order-${i}`}>
                    <span className="aa-eyebrow w-7 mt-1">{String(i + 1).padStart(2, "0")}</span>
                    <div className="flex-1">
                      <div className="font-display text-lg">{s.step}</div>
                      <div className="text-sm text-[var(--aa-text-2)] mt-0.5 leading-relaxed">{s.note}</div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            <div className="aa-card aa-card-sage p-7 mt-6">
              <div className="aa-eyebrow mb-4">How much to use</div>
              <ul className="space-y-3">
                {data.amounts.map((a, i) => (
                  <li key={i} className="border-t border-[var(--aa-elevated)] first:border-0 first:pt-0 pt-3" data-testid={`tip-amount-${i}`}>
                    <div className="font-display text-base">{a.product}</div>
                    <div className="text-sm text-[var(--aa-text-2)] mt-0.5 leading-relaxed">{a.amount}</div>
                    {a.note && <div className="text-sm italic text-[var(--aa-text-3)] mt-2 leading-relaxed">{a.note}</div>}
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-8">
              <Link to="/dashboard" className="aa-cta-secondary">← Back to dashboard</Link>
            </div>
          </>
        )}
      </section>
    </div>
  );
}
